<template>
  <aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <div>
      <section class="sidebar">
        <div class="user-container">
          <table class="table__user-info">
            <tbody>
            <tr>
              <td>
                <div class="user-logo">
                  <a href="https://atosa.asia/" target="_blank">
                    <img src="/static/img/logo.png" alt="user_logo" style="padding: 3px !important;"/>
                  </a>
                </div>
              </td>
              <td>
                <template>
                  {{ $t('hi') }}, <a href="javascript:void(0)" class="a-link-name"
                                     @click="$router.push('/info')">{{ $store.state.userInfo.display_name }}</a>
                  <div>
                    <div
                      style="width:8px; display: inline-block; height:8px; background-color:greenyellow; border-radius:50vh;"></div>
                    {{ $t('base.active') }}
                    <el-dropdown @command="m__handle_command">
                <span class="el-dropdown-link" style="font-size:12px; ">
                  <span class="ti-angle-down" style="color: orangered; cursor:pointer; margin:4px;"/>
                </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="change_profile"><span
                          class="el-icon-user-solid"/>&nbsp; {{ $t('base.profile') }}
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="!selected_menu || selected_menu === 'advanced'"
                          command="switch_basic_menu">
                          <span class="el-icon-refresh"/>&nbsp;
                          {{ $t('menu.use_basic_menu') }}
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-else
                          command="switch_advanced_menu"><span
                          class="el-icon-refresh"/>&nbsp;
                          {{ $t('menu.use_advanced_menu') }}
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="change_password"><span
                          class="el-icon-edit"/>&nbsp; {{ $t('base.change_password') }}
                        </el-dropdown-item>
                        <el-dropdown-item command="logout"><span
                          class="el-icon-switch-button"/>&nbsp;&nbsp;{{ $t('menu.logout_account') }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div style="height: 3px"></div>
              </td>
            </tr>
            <tr>
              <td style="padding:15px; text-align: left; ; font-size: 12px">
                &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('base.balance') }}:
              </td>
              <td style="padding:5px;">
                &nbsp;&nbsp;<strong
                style="background-color: tomato; padding:3px 6px; border-radius: 3px; color:white;">{{
                  $store.state.userInfo.store_current_money| currency
                }}</strong>
                <span>VND</span>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div style="height: 6px"></div>
              </td>
            </tr>
            <tr>
              <td style="padding:15px; text-align: left; ; font-size: 12px">
                &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('base.pack') }}:
              </td>
              <td style="padding:5px;">
                &nbsp;&nbsp;<strong style="color: #125570; ; font-size: 12px; cursor: pointer;"
                                    @click="$router.push('/product-pack')">
                {{ m__get_current_pack() }}
              </strong>
              </td>
            </tr>
            <tr>
              <td style="padding:15px; text-align: left; ; font-size: 12px">
                &nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td style="padding:5px;">
                &nbsp;&nbsp;<strong style="color: #125570; font-size: 12px; cursor: pointer;"
                                    @click="$router.push('/product-pack')">
                {{ m__get_license_to() }}
              </strong>
              </td>
            </tr>
            <tr v-if="false && enable_global">
              <td style="padding:15px; text-align: left; ; font-size: 12px">
                &nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td style="padding:5px;">
                &nbsp;&nbsp;
                <el-dropdown trigger="click">
                  <div class="el-dropdown-link" style="padding-top: 10px">
                    <strong v-if="$i18n.locale === 'vi'"
                            style="color: #125570; font-size: 12px !important; cursor: pointer;">
                      {{ $i18n.locale === 'vi' ? 'Tiếng Việt' : 'Vietnamese' }}
                    </strong>
                    <strong v-if="$i18n.locale === 'en'"
                            style="color: #125570; font-size: 12px !important; cursor: pointer;">
                      English
                    </strong>
                    &nbsp;
                    <i class="el-icon-arrow-down" style="font-weight: bold !important;"></i>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="m__set_language('vi')">
                      {{ $i18n.locale === 'vi' ? 'Tiếng Việt' : 'Vietnamese' }}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="m__set_language('en')">
                      {{ 'English' }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div style="height: 6px"></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div style="clear:both"></div>

        <div style="margin-top: 10px; padding: 5px 10px">
          <el-carousel class="el-carousel-fixed" height="80px" arrow="never" :interval="20000">
            <el-carousel-item v-for="item in carousel_list" :key="item.url">
              <img :src="item.url" alt=""
                   style="width: 100%; height: 100%; cursor: pointer"
                   @click="m__handle_carousel_item_click(item)">
            </el-carousel-item>
          </el-carousel>
        </div>

        <ul v-if="!selected_menu || selected_menu === 'advanced'" id="advanced-menu" class="sidebar-menu mt-[10px]">
          <li
            v-if="m__has_package('shopee_marketing_analysis') || m__has_package('shopee_marketing_survey') || m__has_package('shopee_analysis') || m__has_package('shopee_analysis_spoiler') || m__check_marketing_package('spoil_ads') || m__check_marketing_package('shopee_trend')"
            class="header">
            {{ $t('menu.shopee_analysis').toUpperCase() }}
          </li>
          <li
            v-if="m__has_package('shopee_marketing_analysis') || m__has_package('shopee_marketing_survey') || m__has_package('shopee_analysis')">
            <router-link to="/analysis">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.shop_analysis') }}</span>
            </router-link>
          </li>
          <li v-if="m__has_package('shopee_marketing_survey') || m__has_package('shopee_analysis')">
            <router-link to="/agency-survey">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.shopee_research') }}</span>
            </router-link>
          </li>
          <li
            v-if="m__has_package('shopee_marketing_survey') || m__has_package('shopee_analysis_spoiler') || m__check_marketing_package('spoil_ads') || m__check_marketing_package('shopee_trend')">
            <router-link to="/shopee-trend">
              <i class="el-icon-s-opportunity"/>
              <span>Shopee Trend</span>
            </router-link>
          </li>

          <li
            v-if="has_agency_plan() || m__check_marketing_package('agency_plan') || m__has_package('shopee_marketing_plan')"
            class="header">
            {{ $t('menu.planning').toUpperCase() }}
          </li>
          <li
            v-if="has_agency_plan() || m__check_marketing_package('agency_plan') || m__has_package('shopee_marketing_plan')">
            <router-link to="/agency-plan">
              <i class="el-icon-tickets"/>
              <span>{{ $t('menu.ads_planning') }}</span>
            </router-link>
          </li>
          <li
            v-if="has_agency_plan() || m__check_marketing_package('agency_plan') || m__has_package('shopee_marketing_plan')">
            <router-link to="/agency-plan-order">
              <i class="el-icon-tickets"/>
              <span>{{ $t('menu.order_planning') }}</span>
            </router-link>
          </li>

          <li class="header">{{ $t('menu.atosa_tools').toUpperCase() }}</li>
          <li>
            <router-link to="/keyword">
              <i class="ti-search"/>
              <span>{{ $t('menu.atosa_keyword_tool') }}</span>
            </router-link>
          </li>

          <template v-if="m__has_package('shopee_marketing')">
            <li class="header">{{ $t('menu.shopee_ads').toUpperCase() }}</li>
            <li>
              <router-link to="/marketing/pas">
                <i class="ti-align-justify"/>
                <span>{{ $t('menu.automatic_ads') }}</span>
              </router-link>
            </li>
          </template>
          <li v-if="atosa_ai_performance">
            <router-link to="/marketing/log/atosa_ai_performance">
              <i class="el-icon-s-data"/>
              <span>{{ 'Báo cáo Atosa Agent' }}</span>
            </router-link>
          </li>
          <li
            v-if="m__has_package('shopee_marketing_survey') || m__has_package('shopee_analysis_spoiler') || m__check_marketing_package('spoil_ads')">
            <router-link to="/spoil-ads">
              <i class="el-icon-aim"/>
              <span>{{ $t('menu.ad_position_check') }}</span>
            </router-link>
          </li>


          <li class="header">{{ $t('menu.automatic_marketing').toUpperCase() }}</li>
          <li>
            <router-link to="/shop-product">
              <i class="el-icon-receiving"/>
              <span>{{ $t('menu.shop_products') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/flash-sale">
              <i class="ti-bolt-alt"/>
              <span>{{ $t('menu.shop_flash_sale') }}</span>
            </router-link>
          </li>
          <li
            v-if="m__has_package('shopee_marketing_fs') || m__check_marketing_package('flash_sale_advanced') || flash_sale_advanced_list.includes($store.state.userInfo.username)">
            <router-link to="/shopee-flash-sale">
              <i class="ti-bolt-alt"/>
              <span>{{ $t('menu.shopee_flash_sale') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/voucher">
              <i class="ti-bolt-alt"/>
              <span>{{ $t('menu.shop_vouchers') }}</span>
            </router-link>
          </li>

          <li
            v-if="m__check_marketing_package('data_center') || m__check_marketing_package('order_center') || has_advanced_ads()"
            class="header">{{ $t('menu.reporting').toUpperCase() }}
          </li>
          <li v-if="m__check_marketing_package('data_center')">
            <router-link to="/data-center">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.business_insights') }}</span>
            </router-link>
          </li>
          <li v-if="has_advanced_ads()">
            <router-link to="/ads-center">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.ads_insights') }}</span>
            </router-link>
          </li>
          <li v-if="m__check_marketing_package('data_center')">
            <router-link to="/monthly-report">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.monthly_reporting') }}</span>
            </router-link>
          </li>
          <li
            v-if="array_to_set(custom_report_fixed_list).has($store.state.userInfo.username) && m__check_marketing_package('data_center')">
            <router-link to="/flash-sale-report">
              <i class="el-icon-s-data"/>
              <span>{{ 'Báo cáo theo tháng Custom' }}</span>
            </router-link>
          </li>
          <li v-if="m__check_marketing_package('order_center')">
            <router-link to="/order-center">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.customer_insights') }}</span>
            </router-link>
          </li>

          <li class="header">{{ $t('menu.management').toUpperCase() }}</li>
          <li>
            <router-link to="/shop">
              <i class="ti-home"/>
              <span>{{ $t('menu.shopee_shops') }}</span>
            </router-link>
          </li>
          <li v-if="m__check_marketing_package('sub_account')">
            <router-link to="/sub-account">
              <i class="el-icon-user"/>
              <span>{{ $t('menu.sub_accounts') }}</span>
            </router-link>
          </li>

          <li class="header">{{ $t('menu.package') }} / {{ $t('menu.payment') }}</li>
          <li>
            <router-link to="/product-pack"><i class="ti-package package-logo"/>
              <span>{{ $t('menu.atosa_packages') }}</span>
            </router-link>
          </li>
          <li>
            <a href="javascript:void(0)"
               @click="open_link(`https://banhang.atosa.asia/authenticate/handle?redirect=%2Fpayment%2Ftransfer%3Fchannel%3Dshopee_marketing,shopee_marketing_survey,shopee_analysis,shopee_analysis_spoiler%26package_id%3D%26quantity%3D3%26voucher_code%3D&token=${$store.state.userInfo.token}`)">
              <i class="ti-wallet payment-logo"/>
              {{ $t('menu.topup_payment') }}
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.quangcaoshopee.com"><i class="ti-blackboard learning-logo"/>
              <span>{{ $t('menu.shopee_ads_course') }}</span>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://atosa.asia/huong-dan-cach-dang-ky-shopee-mall/">
              <i class="ti-wordpress mall-logo"/>
              <span>{{ $t('menu.shopee_mall_offering') }}</span>
            </a>
          </li>

          <li class="header">{{ $t('menu.operation').toUpperCase() }}</li>
          <li>
            <router-link to="/affiliate">
              <i class="el-icon-share"/>
              <span>{{ $t('menu.affiliate') }}</span>
            </router-link>
          </li>
          <li>
            <a href="http://hotro.atosa.asia" target="_blank">
              <i class="el-icon-notebook-1"/>
              {{ $t('menu.user_guide') }}
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" @click="download_app = true">
              <i class="ti-desktop"></i> <span>{{ $t('menu.download_desktop_app') }}</span>
            </a>
          </li>
          <li>
            <a href="https://www.messenger.com/t/104406444763487" target="_blank">
              <i class="el-icon-headset"></i> <span>{{ $t('menu.customer_support_channel') }}</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" @click="m_try_logout">
              <i class="ti-shift-left"></i> <span>{{ $t('menu.logout_account') }}</span>
            </a>
          </li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
        </ul>

        <ul v-if="selected_menu === 'basic'" id="basic-menu" class="sidebar-menu">
          <li class="header">{{ $t('menu.package') }} / {{ $t('menu.payment') }}</li>
          <li>
            <router-link to="/product-pack"><i class="ti-package package-logo"/>
              <span>{{ $t('menu.atosa_packages') }}</span>
            </router-link>
          </li>
          <li>
            <a href="javascript:void(0)"
               @click="open_link(`https://banhang.atosa.asia/authenticate/handle?redirect=%2Fpayment%2Ftransfer%3Fchannel%3Dshopee_marketing,shopee_marketing_survey,shopee_analysis,shopee_analysis_spoiler%26package_id%3D%26quantity%3D3%26voucher_code%3D&token=${$store.state.userInfo.token}`)">
              <i class="ti-wallet payment-logo"/>
              {{ $t('menu.topup_payment') }}
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.quangcaoshopee.com"><i class="ti-blackboard learning-logo"/>
              <span>{{ $t('menu.shopee_ads_course') }}</span>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://atosa.asia/huong-dan-cach-dang-ky-shopee-mall/">
              <i class="ti-wordpress mall-logo"/>
              <span>{{ $t('menu.shopee_mall_offering') }}</span>
            </a>
          </li>

          <li class="header">{{ $t('menu.management').toUpperCase() }}</li>
          <li>
            <router-link to="/shop">
              <i class="ti-home"/>
              <span>{{ $t('menu.shopee_shops') }}</span>
            </router-link>
          </li>
          <li v-if="m__check_marketing_package('data_center')">
            <router-link to="/data-center">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.business_insights') }}</span>
            </router-link>
          </li>
          <li v-if="has_advanced_ads()">
            <router-link to="/ads-center">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.ads_insights') }}</span>
            </router-link>
          </li>
          <li v-if="m__check_marketing_package('data_center')">
            <router-link to="/monthly-report">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.monthly_reporting') }}</span>
            </router-link>
          </li>
          <li v-if="m__check_marketing_package('order_center')">
            <router-link to="/order-center">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.customer_insights') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/shop-product">
              <i class="el-icon-receiving"/>
              <span>{{ $t('menu.shop_products') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/sub-account">
              <i class="el-icon-user"/>
              <span>{{ $t('menu.sub_accounts') }}</span>
            </router-link>
          </li>

          <li class="header">{{ $t('menu.atosa_tools').toUpperCase() }}</li>
          <li>
            <router-link to="/keyword">
              <i class="ti-search"/>
              <span>{{ $t('menu.atosa_keyword_tool') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/flash-sale">
              <i class="ti-bolt-alt"/>
              <span>{{ $t('menu.shop_flash_sale') }}</span>
            </router-link>
          </li>
          <li
            v-if="m__has_package('shopee_marketing_fs') || m__check_marketing_package('flash_sale_advanced') || flash_sale_advanced_list.includes($store.state.userInfo.username)">
            <router-link to="/shopee-flash-sale">
              <i class="ti-bolt-alt"/>
              <span>{{ $t('menu.shopee_flash_sale') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/voucher">
              <i class="ti-bolt-alt"/>
              <span>{{ $t('menu.shop_vouchers') }}</span>
            </router-link>
          </li>
          <li
            v-if="m__has_package('shopee_marketing_analysis') || m__has_package('shopee_marketing_survey') || m__has_package('shopee_analysis')">
            <router-link to="/analysis">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.shop_analysis') }}</span>
            </router-link>
          </li>
          <li v-if="m__has_package('shopee_marketing_survey') || m__has_package('shopee_analysis')">
            <router-link to="/agency-survey">
              <i class="el-icon-s-data"/>
              <span>{{ $t('menu.shopee_research') }}</span>
            </router-link>
          </li>
          <li
            v-if="m__has_package('shopee_marketing_survey') || m__has_package('shopee_analysis_spoiler') || m__check_marketing_package('spoil_ads') || m__check_marketing_package('shopee_trend')">
            <router-link to="/shopee-trend">
              <i class="el-icon-s-opportunity"/>
              <span>Shopee Trend</span>
            </router-link>
          </li>
          <li
            v-if="m__has_package('shopee_marketing_survey') || m__has_package('shopee_analysis_spoiler') || m__check_marketing_package('spoil_ads')">
            <router-link to="/spoil-ads">
              <i class="el-icon-aim"/>
              <span>{{ $t('menu.ad_position_check') }}</span>
            </router-link>
          </li>
          <li
            v-if="has_agency_plan() || m__check_marketing_package('agency_plan') || m__has_package('shopee_marketing_plan')">
            <router-link to="/agency-plan">
              <i class="el-icon-tickets"/>
              <span>{{ $t('menu.ads_planning') }}</span>
            </router-link>
          </li>
          <li v-if="douyin_fixed_list.includes($store.state.userInfo.username)">
            <router-link to="/agency-plan-order">
              <i class="el-icon-tickets"/>
              <span>{{ $t('menu.order_planning') }}</span>
            </router-link>
          </li>

          <template v-if="m__has_package('shopee_marketing')">
            <li class="header">{{ $t('menu.shopee_ads').toUpperCase() }}</li>
            <li>
              <router-link to="/marketing/pas">
                <i class="ti-align-justify"/>
                <span>{{ $t('menu.automatic_ads') }}</span>
              </router-link>
            </li>
          </template>

          <li class="header">{{ $t('menu.operation').toUpperCase() }}</li>
          <li>
            <router-link to="/affiliate">
              <i class="el-icon-share"/>
              <span>{{ $t('menu.affiliate') }}</span>
            </router-link>
          </li>
          <li>
            <a href="http://hotro.atosa.asia" target="_blank">
              <i class="el-icon-notebook-1"/>
              {{ $t('menu.user_guide') }}
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" @click="download_app = true">
              <i class="ti-desktop"></i> <span>{{ $t('menu.download_desktop_app') }}</span>
            </a>
          </li>
          <li>
            <a href="https://www.messenger.com/t/104406444763487" target="_blank">
              <i class="el-icon-headset"></i> <span>{{ $t('menu.customer_support_channel') }}</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" @click="m_try_logout">
              <i class="ti-shift-left"></i> <span>{{ $t('menu.logout_account') }}</span>
            </a>
          </li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
          <li>&nbsp;</li>
        </ul>
      </section>

      <!-- /.sidebar -->
    </div>

    <el-dialog :visible.sync="download_app" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 14px">{{ $t('menu.select_os') }}</strong>

        <el-row :gutter="12" style="margin-top: 20px">
          <el-col :span="12">
            <div :class="os_type === 'windows' ? 'card-fixed-active' : 'card-fixed'"
                 @click="os_type = 'windows'; m__download_app()">
              <el-card :shadow="os_type === 'windows' ? 'always' : 'never'" style="vertical-align: middle">
                <div style="height: 30px; line-height: 30px">
                  <i style="font-size: 26px; vertical-align: middle; color: #0bace6" class="fa fa-windows"></i>
                  &nbsp;&nbsp;&nbsp;
                  <strong style="vertical-align: middle">Windows</strong>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :span="12">
            <div :class="os_type === 'macos' ? 'card-fixed-active' : 'card-fixed'"
                 @click="os_type = 'macos'; m__download_app()">
              <el-card :shadow="os_type === 'macos' ? 'always' : 'never'">
                <div style="height: 30px; line-height: 30px">
                  <i style="font-size: 26px; vertical-align: middle; color: #949494" class="fa fa-apple"></i>
                  &nbsp;&nbsp;&nbsp;
                  <strong style="vertical-align: middle">Mac OS</strong>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </aside>
</template>
<script>
import {
  agency_plan_fixed_list,
  atosa_advanced_fixed_list, boost_campaign_fixed_list, custom_report_fixed_list,
  douyin_fixed_list, flash_sale_advanced_list, group_campaign_advanced_list, new_buttons_fixed_list,
  quota_fixed_list,
  shop_product_fixed_list,
  survey_fixed_list
} from '../../../addon/fixed_list'
import {package_mixins} from "../../../mixins/package";

export default {
  name: 'DashboardSidebar',

  mixins: [package_mixins],

  data() {
    return {
      interval_update: null,
      feature_list: [],
      survey_fixed_list,
      quota_fixed_list,
      shop_product_fixed_list,
      agency_plan_fixed_list,
      atosa_advanced_fixed_list,
      douyin_fixed_list,
      flash_sale_advanced_list,
      boost_campaign_fixed_list,
      group_campaign_advanced_list,
      new_buttons_fixed_list,
      custom_report_fixed_list,
      fetched: false,
      download_app: false,
      os_type: '',
      auto_apply_package: false,
      selected_menu: 'advanced',
      carousel_list: [
        {
          url: '/static/img/carousel/2.png',
          router_push: '/affiliate',
          open_link: ''
        },
        {
          url: '/static/img/carousel/1.png',
          router_push: '',
          open_link: 'https://atosa.asia/huong-dan-cach-dang-ky-shopee-mall/'
        },
        {
          url: '/static/img/carousel/3.png',
          router_push: '',
          open_link: 'https://bit.ly/3WkbPVh'
        },
      ],

      atosa_ai_performance: false
    }
  },

  beforeMount() {
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
      this.os_type = 'macos'
    } else {
      this.os_type = 'windows'
    }

    this.selected_menu = localStorage.getItem('sidebar_display_type')

    this.$http.post(
      this.API.URL_API_SRV_2 + '/mipee/atosa_agent/applying_atosa_agent', {}, this.cf())
      .then((response) => {
        this.atosa_ai_performance = response.body.data.applying
      })
  },

  beforeRouteLeave(to, from, next) {
    clearInterval(this.interval_update)
    next()
  },

  mounted: async function () {
    await this.m__is_auto_apply_package()

    this.EB.$on('show_download_app_dialog', () => this.download_app = true)
  },

  methods: {
    m__set_language(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', this.$i18n.locale)
    },

    m__handle_carousel_item_click(item) {
      if (item.router_push) this.$router.push(item.router_push)
      if (item.open_link) this.open_link(item.open_link)
    },

    async m__is_auto_apply_package() {
      try {
        const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/is_auto_apply_package', this.cf())
        this.$store.state.auto_apply_package = this.auto_apply_package = response.body.data
      } catch (e) {
      }
    },

    m__download_app() {
      let download_url = 'https://static.atosa.vn/download/atosa-setup.exe'
      // if (this.os_type === 'macos') download_url = 'https://static.atosa.vn/download/atosa-v1.0.1.2024430.dmg'
      if (this.os_type === 'macos') download_url = 'https://static.atosa.vn/download/atosa-setup.dmg'

      window.open(download_url, '_blank').focus()
      this.download_app = false
    },

    m__get_current_pack() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (extent_package) {
        return extent_package.package.name.replace(/SHOPEE MARKETING - /ig, '')
      } else {
        return ''
      }
    },

    m__get_license_to() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (extent_package) {
        return this.dayjs(extent_package.license_to).format('DD/MM/YYYY HH:mm')
      } else {
        return ''
      }
    },

    m__handle_command(cmd) {
      if (['change_password', 'change_profile'].includes(cmd)) {
        this.$router.push(`/info?tab=${['change_profile', 'change_password'].indexOf(cmd)}`)
      } else if (cmd === 'switch_advanced_menu') {
        this.selected_menu = 'advanced'
        localStorage.setItem('sidebar_display_type', 'advanced')
      } else if (cmd === 'switch_basic_menu') {
        this.selected_menu = 'basic'
        localStorage.setItem('sidebar_display_type', 'basic')
      } else {
        this.m_try_logout()
      }
    },

    m_try_logout() {
      localStorage.clear()
      this.$store.state.userInfo = null
      this.$store.dispatch('update_userInfo', {})
      this.$router.push(`/login?r=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss">
.sale-logo {
  background: linear-gradient(to bottom right, #00FF40, #800080) !important;
  border-radius: 4px;
  color: white;
  margin-left: -4px;

  padding: 2px 6px;

}

.main-sidebar {
  background-color: white;
  width: 230px !important;
  height: calc(100vh - 100px) !important;
  overflow-y: scroll;

  .table__user-info {
    width: 100%;

    tbody {
      tr {
        td:first-child {
          width: 60px;
          text-align: center;
          padding: 10px;

          div {
            //background: linear-gradient(to bottom right, #F3A41F, #AE04A2);
            border-radius: 50vh;
            padding: 1px;

            img {
              padding: 5px;
              background-color: white;
              width: 100%;
              border-radius: 50vh;
            }
          }
        }
      }
    }
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;

    &:hover {
      background-color: rgb(90, 90, 90);
    }
  }
}

.main-sidebar, .left-side {
  top: 0 !important;
}

.sidebar-menu {
  a {
    color: gray !important;
  }
}

.payment-logo {
  background: linear-gradient(to bottom right, #FF0000, #800080) !important;
  border-radius: 4px;
  color: white;
  margin-left: -4px;

  padding: 2px 6px;

}

.learning-logo {
  background: linear-gradient(to bottom right, #f7462e, #ACCA06) !important;
  border-radius: 4px;
  color: white;
  margin-left: -4px;

  padding: 2px 6px;
}

.mall-logo {
  //background: linear-gradient(to bottom right, #FF0104, #976F14) !important;
  background: linear-gradient(to bottom right, #FDB74D, #FF404F) !important;
  //background: linear-gradient(to bottom right, #FF0000, #800080) !important;
  border-radius: 4px;
  color: white;
  margin-left: -4px;
  padding: 2px 6px;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg); /* Safari and Chrome */
}

.package-logo {
  background: linear-gradient(to bottom right, #FDB74D, #FF404F) !important;
  border-radius: 4px;
  color: white;
  margin-left: -4px;
  padding: 2px 6px;
}

.help-logo {
  background: linear-gradient(to bottom right, #09c6f9, #045de9) !important;
  border-radius: 4px;
  color: white;
  margin-left: -4px;
  padding: 2px 6px;
}
</style>

<style lang="scss">
.el-carousel-fixed {
  .el-carousel__button {
    width: 5px !important;
    height: 5px !important;
    border-radius: 5px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/dashboard/partials/Sidebar.vue